(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["text-truncated"] && !Shopify.designMode) return;
  try {
    // Event delegation op document i.p.v. listeners per element op
  // DOMContentLoaded: dit block wordt herrenderd door de Section Rendering
  // API (theme editor live preview, filters), en een link die pas na de
  // eerste page load verschijnt zou anders geen handler krijgen.
  document.addEventListener('click', function (e) {
    const link = e.target.closest('.text-truncated-read-more');
    if (!link) return;

    e.preventDefault();

    const expandTargetId = link.getAttribute('data-expand-target');
    if (expandTargetId) {
      const expandTarget = document.getElementById(expandTargetId);
      if (!expandTarget) return;

      const isExpanded = expandTarget.classList.toggle('is-expanded');
      link.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      link.textContent = isExpanded
        ? link.getAttribute('data-read-less-text')
        : link.getAttribute('data-read-more-text');
      return;
    }

    const targetSelector = link.getAttribute('data-scroll-target');
    if (!targetSelector) return;

    const targetElement = document.querySelector(targetSelector);
    if (targetElement) {
      // Calculate position with offset
      const offset = 120; // Offset in pixels (adjust as needed)
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vestiging-video"] && !Shopify.designMode) return;
  try {
    (() => {
    // Bij een embed via URL kent Liquid de beeldverhouding van de video niet:
    // video.aspect_ratio bestaat alleen voor échte Shopify-video-objecten, en
    // YouTube's oEmbed-endpoint stuurt geen CORS-header (én rapporteert een
    // genormaliseerde 200x113). Wat wél werkt: YouTube publiceert voor video's
    // die niet 16:9 zijn een extra thumbnail op /oardefault.jpg ("original
    // aspect ratio") met de werkelijke afmetingen; bij een 16:9-video geeft
    // die URL een 404. Die afbeelding meten we hier, en de gemeten ratio
    // overschrijft de startwaarde uit de blok-instelling.
    //
    // Faalt de detectie (404, adblocker, offline), dan gebeurt er niets en
    // blijft de serverzijdige ratio staan — de video werkt dan gewoon zoals
    // voorheen.
    const MIN_SIZE = 200; // 404's leveren een 120x90 placeholder-jpeg
    const SELECTOR = '[data-vestiging-video-id]';

    const detect = (el) => {
      if (el.dataset.vestigingVideoRatioInit) return;
      el.dataset.vestigingVideoRatioInit = 'true';

      const id = el.dataset.vestigingVideoId;
      if (!id || el.dataset.vestigingVideoType !== 'youtube') return;

      const probe = new Image();
      // Anonieme CORS-request: i.ytimg.com staat dit toe (access-control-allow-origin: *)
      // en zo stuurt de browser geen cookies mee naar YouTube.
      probe.crossOrigin = 'anonymous';
      probe.onload = () => {
        const { naturalWidth: width, naturalHeight: height } = probe;
        if (width < MIN_SIZE || height < MIN_SIZE) return;

        el.style.setProperty('--size-style-aspect-ratio', `${width}/${height}`);
        el.classList.toggle('vestiging-video--portrait', height > width);
      };
      probe.src = `https://i.ytimg.com/vi/${encodeURIComponent(id)}/oardefault.jpg`;
    };

    // Init per element i.p.v. een eenmalige DOMContentLoaded-scan, omdat de
    // theme-editor blocks na een instelling-wijziging vervangt via de Section
    // Rendering API (zonder page-reload).
    const scan = (root) => {
      root.querySelectorAll?.(SELECTOR).forEach(detect);
      if (root.matches?.(SELECTOR)) detect(root);
    };

    scan(document);

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) scan(node);
        });
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
